export class Role {
    id!: string
    name!: string
    normalizedName!: string
    concurrencyStamp: any
  }
  